import React from "react";
import axios from "axios";
import CourseView from "./CourseView";

import * as Globals from "./../Globals";

export default class CourseOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: undefined,
      searchFiler: "",
      viewID: -1
    };
  }

  componentDidMount() {
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(Globals.BASE_PATH + "api/courses", {
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookie
        }
      })
      .then(response => {
        this.setState({
          courses: response.data.data
        });
      })
      .catch(error => {
        this.props.CheckAuthError(error);
      });
  }
  handleViewRequest(id) {
    this.setState({
      viewID: id
    });
  }
  handleCourseListRequest() {
    this.setState({
      viewID: -1
    });
  }

  handleSearchFilterChange(event) {
    this.setState({
      searchFiler: event.target.value
    });
  }

  renderCourseOverview() {
    if (this.state.courses === undefined) {
      return (
        <ul className="list-group">
          <li className="list-group-item">
            <p className="text-center" style={{ margin: 0 }}>
              <b>Kurse werden geladen.</b>
            </p>
          </li>
        </ul>
      );
    } else if (this.state.courses.length === 0) {
      return (
        <ul className="list-group">
          <li className="list-group-item">
            <p className="text-center" style={{ margin: 0 }}>
              <b>Es wurden keine Kurse gefunden.</b>
            </p>
          </li>
        </ul>
      );
    } else {
      return (
        <div>
          <ul className="list-group">
            <li className="list-group-item">
              <div className="form-inline">
                <div className="form-group">
                  <label style={{ marginRight: "10px" }}>Kursnummernsuche:</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={e => this.handleSearchFilterChange(e)}
                  />
                </div>
              </div>
            </li>
            {this.state.courses.map((course, index) => {
              if (course.id.toString().indexOf(this.state.searchFiler) !== -1) {
                let datum = new Date(course["start-date"]);
                return (
                  <li key={index} className="list-group-item">
                    <div className="float-left specialBlock">
                      <label className="lb-md">{`${course.address.name} - ${datum.toLocaleDateString()}`}</label>
                      <p className="text-small">{course["course-topic"].name}</p>
                    </div>
                    <div className="float-right">
                      <button
                        className="btn btn-default float-right btn-courseOverview"
                        type="button"
                        onClick={() => this.handleViewRequest(course.id)}
                      >
                        Anzeigen
                      </button>
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      );
    }
  }

  getRenderBlock() {
    if (this.state.viewID < 0) {
      return (
        <div>
          <div className="container greeting">
            <h2 className="text-center">
              Herzlich Willkommen, {this.props.sex === "male" ? "Herr" : "Frau"}{" "}
              {this.props.firstname} {this.props.lastname}!
            </h2>
            <h4 className="text-center">Sie sind eingeloggt als Administrator.</h4>
          </div>
          <div className="container courses">
            <h1>Kursübersicht</h1>
            {this.renderCourseOverview()}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <CourseView
            CheckAuthError={this.props.CheckAuthError}
            LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet}
            id={this.state.viewID}
            sendCourseListRequest={this.handleCourseListRequest.bind(this)}
          />
        </div>
      );
    }
  }
  render() {
    return this.getRenderBlock();
  }
}



// WEBPACK FOOTER //
// ./src/admin/CourseOverview.js